export default __webpack_public_path__ + "static/media/9_2_hl.655fe33c.png";